// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"21dd9826","52":"f15146f3","58":"e91e2422","83":"4004b39e","299":"0be81c08","453":"1fb67467","754":"9d9fe5f0","918":"74e4a515"}[chunkId] + ".chunk.js";
};